import React, { useState, useEffect, Suspense } from "react";
import "./Homepage.css";
import Container from "react-bootstrap/Container";
import TopMobileSearch from "./TopMobileSearch";
import SkeletonLoader from "../Atomics/SkeletonLoader";
import Section from "../Atomics/Section";
import { boxFetcher, broadcastFetcher } from "../../api/requests";
import useInView from "../../hook/IntersectionObservor";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import LoadingIndicator from "../Atomics/Loading/Loading";

const FatFooter = React.lazy(() => import("../Footer/FatFooter"));

const Homepage = () => {
  const [structure, setStructure] = useState(null);
  const [loading, setLoading] = useState(true);
  const isFooterVisible = useInView("fat-footer");

  // const testBroadcast = async () => {
  //   try {
  //     const res = await broadcastFetcher.sendMessage({
  //       message: "سلام، این یک پیام تست می باشد.",
  //     });

  //     console.log(res);
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  useEffect(() => {
    const fetchStructure = async () => {
      try {
        const res = await boxFetcher.get(1);
        if (res) {
          setStructure(res);
        }
      } catch (err) {
        console.error("Error fetching structure:", err);
      } finally {
        setLoading(false);
      }
    };

    // testBroadcast();
    fetchStructure();
  }, []);

  return (
    <ContentWrapper>
      <Container
        fluid
        className="pb-0"
        style={{
          textAlign: "center",
          minHeight: "calc(100vh - 81px)",
        }}
      >
        <TopMobileSearch />

        {loading ? (
          <div style={{ marginTop: "20px" }}>
            <LoadingIndicator />
          </div>
        ) : (
          structure?.results.map((item, index) => (
            <Section key={index} section={item} />
          ))
        )}
      </Container>

      <div id="fat-footer">
        {isFooterVisible ? (
          <Suspense fallback={<SkeletonLoader />}>
            <FatFooter />
          </Suspense>
        ) : (
          <SkeletonLoader />
        )}
      </div>
    </ContentWrapper>
  );
};

export default Homepage;
